import { forwardRef, HTMLAttributes, Ref } from 'react'
import classNames from 'classnames'
import './ChannelsLine.scss'
import { Position } from '../../types'
import { useVisiblePositionPercent } from '../hooks/useVisiblePositionPercent'

interface Props extends HTMLAttributes<HTMLDivElement> {
  position: Position
}

export const ChannelsLine = forwardRef(
  ({ position, className, children, ...attrs }: Props, ref: Ref<HTMLDivElement> | undefined) => {
    const percent = useVisiblePositionPercent(position)

    return (
      <div className={classNames('ChannelsLine', className)} style={{ left: `${percent}%` }} {...attrs} ref={ref} />
    )
  },
)
